
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl';
import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import {IntlProvider} from 'react-intl';
import {getLocale} from '../locales';
import {getMessages} from '../getMessages';
import "./Registration.scss";
import Logo from '../app/Logo.react';
import {defaultOptions} from '../app/auth';
import Auth0Lock from 'auth0-lock';
import Auth0Variables from '../app/auth0-variables';
import {displayError} from '../app/errorDisplayer';
import {isEmbeddedLogin} from '../../outlook/dialog';
import deepCopy from 'deep-copy';
import EventTracker from '../app/EventTracker';
import {expiredTokenHash} from '../../../packages/extension/src/background/Token';
import Deferred from '../fw/deferred';

/* eslint react/jsx-sort-props: 0 */

export const messages = defineMessages({
    newsletter: {id: 'registration.newsletter', 'defaultMessage': 'Receive monthly newsletter'},
    agree1: {id: 'registration.signupTerm1', 'defaultMessage': 'I agree to the'},
    agree2: {id: 'registration.signupTerm2', 'defaultMessage': 'license agreement'},
});

let loginPromise;
export function login() {
	loginPromise = new Deferred();

	ReactDOM.render(
		<IntlProvider locale={getLocale()} messages={getMessages()}>
			<Login />
		</IntlProvider>,
		document.getElementById('app')
	);

	return loginPromise.promise;
}

class Login_ extends React.Component {

	static propTypes = {
		intl: PropTypes.object,
	};

	static MAX_STEPS = 4;
	constructor() {
		super();

		this.state = {
			step: 1,
			apps: "",
			newsletter: true
		};

		this.skipInstallStep = false;
	}

	componentDidMount() {
		this.initAuth();
	}

	static isLoginExpired() {
		return window.location.hash === expiredTokenHash;
	}

	render() {
		return (
			<div className="Registration Login">
				<header><a href="https://www.dativery.com"><Logo color /></a></header>
				<h2><FormattedMessage defaultMessage="Log In" id="login.topHeader" /></h2>
				{Login_.isLoginExpired() ? <h3 className="warning"><FormattedMessage defaultMessage="Session has expired. Please log in again." id="login.loginExpired" /></h3> : ''}
				{this.renderLogin()}
				<footer>
					<span><FormattedMessage defaultMessage="Don't have an account yet?" id="registration.withAccount" /> </span>
					<a className="switch" href={"/registration" + (window.location.pathname.length > 1 ? "#pathname=" + encodeURI(window.location.pathname) : '')}>
						<FormattedMessage defaultMessage="Sign Up" id="registration.topHeader" />
						<span><svg focusable="false" className="icon-text" width="8px" height="12px" viewBox="0 0 8 12" version="1.1" xmlns="http://www.w3.org/2000/svg"><g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd"><g id="Web/Submit/Active" transform="translate(-148.000000, -32.000000)" fill="#FFFFFF"><polygon id="Shape" points="148 33.4 149.4 32 155.4 38 149.4 44 148 42.6 152.6 38"></polygon></g></g></svg></span>
					</a>
				</footer>
			</div>
		);
	}

	initAuth() {
		let options = deepCopy(defaultOptions);
		options.container = 'authContainer';
		options.theme = {
			logo: undefined,
			primaryColor: '#12b100'
		};
		options.rememberLastLogin = true;
		options.allowSignUp = false;
		options.allowForgotPassword = true;

		if (isEmbeddedLogin()) {
			options.container = undefined;
			options.theme.logo = defaultOptions.theme.logo;
		}
		else {
			options.auth.redirect = false;
		}

		let lock = new Auth0Lock(
			Auth0Variables.AUTH0_CLIENT_ID,
			Auth0Variables.AUTH0_DOMAIN,
			options
		);

		lock.show();

		let self = this;
		lock.on("authenticated", function(authResult) {
			if (Login_.isLoginExpired()) {
				history.pushState("", document.title, window.location.pathname + window.location.search);
			}

			// Use the token in authResult to getProfile() and save it to localStorage
			lock.getProfile(authResult.accessToken, function(error, newProfile) {
				if (error) {
					displayError(error);
					return;
				}

                EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
                    event: 'authentication',
                    type: 'application'
                });

                localStorage.setItem('profile', JSON.stringify(newProfile));
				localStorage.setItem('userToken', authResult.idToken);

				self.finishRegistrion();
			});
		});
	}

	renderLogin() {
		let isActive = true;

		return (
			<div className={"stepBox" + " step-1" + (isActive ? ' active' : '') + ' last' }>
				<div className="wrapper">
					<div className="stepBody">
						<div id="authContainer"></div>
					</div>
				</div>
			</div>
		);
	}

	finishRegistrion() {
		loginPromise.resolve();
	}
}
let Login = injectIntl(Login_);
